export default "__VITE_ASSET__D71y7p02__"